import { render, staticRenderFns } from "./Departments.vue?vue&type=template&id=1c786420&scoped=true&"
import script from "./Departments.vue?vue&type=script&lang=js&"
export * from "./Departments.vue?vue&type=script&lang=js&"
import style0 from "./Departments.vue?vue&type=style&index=0&id=1c786420&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c786420",
  null
  
)

export default component.exports